import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { PendingRequestsService } from '../../_services/_core/pending-requests.service';

export function pendingRequestsInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const pendingRequestsService = inject(PendingRequestsService);

  pendingRequestsService.increment();

  return next(req).pipe(finalize(() => pendingRequestsService.decrement()));
}
